module.exports = __webpack_public_path__ + "media/images/icon_sidebar_month-84020e42bcddd490667e13824f1f69e2.svg";